export const theme = {
  colors: {
    primaryText: 'rgba(51, 51, 51, 1)',
    secondaryText: 'rgb(121, 119, 119)',
    primaryBlue: 'rgba(45, 61, 143, 1)',
    primaryGreen: 'rgba(0, 153, 0, 1)',
    primaryRed: 'rgba(204, 0, 0, 1)',
    subBackground: 'rgb(230, 230, 230)',
    menuText: 'rgba(102, 102, 102, 1)',
    black: 'rgb(0, 0, 0)',
    white: 'rgb(255, 255, 255)',
    border: 'rgb(80, 78, 78)',
    disabledBackground: 'rgba(245, 245, 245, 1)',
    disabledText: 'rgba(170, 170, 170, 1)',
    overlayBackground: 'rgba(0, 0, 0, 0.4)',
    spinnerTrack: '#dddddd',
  },
  fontSizes: {
    large: '2rem',
    medium: '1rem',
    small: '0.9rem',
  },
};
